import { Link } from 'react-router-dom';
import Logo from '../assets/images/logo1.png';
import { IoLogoWhatsapp, IoMail, IoLogoInstagram } from 'react-icons/io5';

const Footer = () => {
  return (
    <footer
      style={{
        fontFamily: "'Montserrat', sans-serif",
      }}
      className="text-[#9D9898] bg-[#090516]"
    >
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8 px-6 lg:px-[90px] pt-12 pb-10">
        {/* Brand & Mission */}
        <div className="md:col-span-2">
          <div className="logo mb-4">
            <Link to="/">
              <img className="w-[120px] sm:w-[150px]" src={Logo} alt="XploreSTEMi Logo" />
            </Link>
          </div>
          <p className="text-sm leading-relaxed text-slate-400 max-w-sm mb-6">
            We create an atmosphere where primary and secondary school students connect classroom concepts to real-world STEM challenges through robotics, coding, and hands-on innovation.
          </p>
          {/* Social Links */}
          <div className="flex items-center gap-3">
            <a
              href="https://chat.whatsapp.com/GbToN7d2xVN7RpDIXMrOLC"
              target="_blank"
              rel="noopener noreferrer"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white hover:bg-emerald-600 transition"
              title="Join us on WhatsApp"
              aria-label="WhatsApp"
            >
              <IoLogoWhatsapp size={18} />
            </a>
            <a
              href="mailto:info@explorestemi.com"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white hover:bg-primary transition"
              title="Send us an email"
              aria-label="Email"
            >
              <IoMail size={18} />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white hover:bg-pink-600 transition"
              title="Follow us on Instagram"
              aria-label="Instagram"
            >
              <IoLogoInstagram size={18} />
            </a>
          </div>
        </div>

        {/* Featured Courses */}
        <div>
          <h5
            style={{
              fontFamily: "'Clash Display', sans-serif",
              fontWeight: 700,
            }}
            className="text-white text-lg mb-4"
          >
            Programs
          </h5>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/training" className="hover:text-white transition">
                Robotics Bootcamp
              </Link>
            </li>
            <li>
              <Link to="/training" className="hover:text-white transition">
                Web Development
              </Link>
            </li>
            <li>
              <Link to="/training" className="hover:text-white transition">
                AI & Machine Learning
              </Link>
            </li>
            <li>
              <Link to="/training" className="hover:text-white transition">
                Hardware & Embedded Systems
              </Link>
            </li>
            <li>
              <Link to="/training" className="hover:text-white transition">
                UI/UX Design
              </Link>
            </li>
          </ul>
        </div>

        {/* Quick Links & Support */}
        <div>
          <h5
            style={{
              fontFamily: "'Clash Display', sans-serif",
              fontWeight: 700,
            }}
            className="text-white text-lg mb-4"
          >
            Explore
          </h5>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/about" className="hover:text-white transition">
                About Our Mission
              </Link>
            </li>
            <li>
              <Link to="/instructors" className="hover:text-white transition">
                Meet the Instructors
              </Link>
            </li>
            <li>
              <Link to="/news" className="hover:text-white transition">
                News & Updates
              </Link>
            </li>
            <li>
              <Link to="/register" className="hover:text-white transition">
                Apply for Bootcamp
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-[#030209] text-white py-4 text-xs px-6 lg:px-[90px] flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-slate-900">
        <p className="text-center sm:text-left text-slate-400">
          © {new Date().getFullYear()} XploreSTEMi. All Rights Reserved. Empowering African Youth in STEM.
        </p>
        <div className="flex items-center gap-4">
          <Link
            to="/admin"
            title="Staff & Admin Portal (Quick key: Ctrl+Shift+A)"
            className="inline-flex items-center gap-1.5 text-slate-400 hover:text-emerald-400 transition-colors py-1 px-2 rounded hover:bg-white/5 text-xs font-medium"
          >
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
            <span>Staff Portal</span>
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;